const normalizeBaseUrl = (value = "") =>
  String(value || "")
    .trim()
    .replace(/\/+$/, "");

export const KINSTA_API_BASE_URL = "https://server-9p4hx.kinsta.app";

const configuredApiBaseUrl = normalizeBaseUrl(
  process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_SERVER ||
    process.env.REACT_APP_API_BASE
);

export const API_BASE_URL = configuredApiBaseUrl || KINSTA_API_BASE_URL;

export const buildApiUrl = (path = "") => {
  if (!path) {
    return API_BASE_URL;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const MASTERDATA_API_BASE = `${API_BASE_URL}/api/masterdata`;
export const STocManager_API_BASE = `${API_BASE_URL}/api/stocmanager`;
export const TASKS_API_BASE = `${API_BASE_URL}/api/tasks`;

export default API_BASE_URL;
